import { CSSProperties } from "react";
import { classNames } from "@ct-react/core";
import spriteUrl from "../../assets/icons-sprite.svg";
import "./sprite-icon.scss";

type Props = {
  hash: string;
  className?: string;
  width?: number;
  bordered?: boolean;
}

const SpriteIcon = ({ hash, className, width = 16, bordered = false }: Props) =>
  (<span className={classNames("sprite-icon", className, { "with-border": bordered })}
         style={{ "--ccv-sprite-icon-size": `${width}px` } as CSSProperties}>
    <svg viewBox="0 0 16 16">
      <use href={`${spriteUrl}#${hash}`} />
    </svg>
  </span>);

export default SpriteIcon;
